/** @flow */

import React from "react";
import classNames from "classnames";
import "./icons.style.scss";

type Props = $Exact<{
  color?: string,
  className?: string,
  rotate?: number,
  onClick?: (event: SyntheticEvent<HTMLButtonElement>) => void,
}>;

const ArrowRightIcon = (props: Props) => (
  <svg
    className={classNames("icons", props.color, props.className, {
      charcoal: !props.color,
    })}
    viewBox="0 0 24 24"
    onClick={props.onClick}
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    style={{ transform: `rotate(${typeof props.rotate === "number" ? props.rotate : 0}deg)` }}
  >
    <g>
      <path d="M20.5,12 L3.5,12 L20.5,12 Z" />
      <polyline points="13 4 21 12 13 20" />
    </g>
  </svg>
);

export default ArrowRightIcon;
